module.exports = __webpack_public_path__ + "img/send_p.a05c5c6e.svg";